export default {
  name: "ViewFooter"
};